export default __webpack_public_path__ + "static/media/telegram_post_osadz.529089e0.webp";